export default __webpack_public_path__ + "static/media/samplePatronCsvData.910bebcb.csv";